import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderRo = () => {
    return (
        <HighlightedText
            text="Răzuiți biletele și obțineți bonusul dumneavoastră"
            highlights={[{ word: 'bonusul dumneavoastră' }]}
            breakAfterWords={['obțineți']}
            className={styles.text_header}
        />
    )
}
